import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { DatePipe, DOCUMENT } from '@angular/common';
import { Component, DestroyRef, ElementRef, HostListener, inject, Inject, OnInit, signal, TemplateRef, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { CountableTimeZonePipe, DocumentPreviewTypes } from 'countable@helpers';
import { RoundingModel, SPIN_STYLES, SpinInputModel, UserDetailModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, finalize, tap } from 'rxjs/operators';
import { FirmModel } from 'src/app/model/firm/firm.model';
import { idleTime, modules } from 'src/app/services/app-config';
import { EngService } from 'src/app/services/eng.service';
import { FirmService } from 'src/app/services/firm.service';
import { TimeTrackerService } from 'src/app/services/time-tracker.service';
import { AclModel } from '../../../../model/acl.model';
import { UngroupModel } from '../../../../model/tb/ungroup.model';
import { HeaderNameModel } from '../../../../model/workbook/header-name.model';
import { WbNoteModel } from '../../../../model/workbook/wb-note.model';
import { AclService } from '../../../../services/acl.service';
import { ApiService } from '../../../../services/api.service';
import { AuthService } from '../../../../services/auth.service';
import { EngApiService } from '../../../../services/eng-api.service';
import { TbApiService } from '../../../../services/tb-api.service';
import { WorkbookService } from '../../../../services/workbook.service';
import { SharedService } from '../../../shared/shared.service';

@Component({
  selector: 'app-income-statement',
  templateUrl: './working-income-statement.component.html',
  styleUrls: ['./working-income-statement.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe],
  standalone: false
})
export class IncomeStatementComponent implements OnInit {

  mapNumData: any;
  trailbalId: any;
  isMapping: boolean = false;
  isincomeStatementExpanded: boolean = true;
  searchText: any;
  @ViewChild('multipleMoveMenu') multipleMoveMenu: MatMenuTrigger;
  @ViewChild('createLeadsheetDialog') createLeadsheetDialog: TemplateRef<any>;
  @ViewChild('saveIncomeLeadsheetDialog') saveLeadsheetalertforIS: TemplateRef<any>;
  @ViewChild('saveIncomeMapNoDialog') saveMapNoalertforIS: TemplateRef<any>;
  @ViewChild('GroupDialogBox') GroupDialogBox: TemplateRef<any>;
  @ViewChild('UngroupDialog') UngroupDialog: TemplateRef<any>;
  @ViewChild('AddgroupDialog') AddgroupDialog: TemplateRef<any>;
  @ViewChild('focusInputField') focusInputField: ElementRef;
  @ViewChild('sortingMenu') sortingMenu: MatMenuTrigger;
  @ViewChild('notesFSLinkingDialog') notesFSLinkingDialog: TemplateRef<any>;
  notesSRc: any;
  accYearEnd: number;
  disablegreenbutton: boolean = true;
  isSelectAll: boolean = false;
  notes: any[] = [];
  private userData: UserDetailModel;
  engagementData: any;
  incomeStatementdetails: any;
  originalIncomeStatementdetails: any;
  selectedLSTrailBLrow: any = [];
  isMoveforIS: boolean;
  isindividualRowSaveforIS: boolean = true;
  isLeadSheet: boolean;
  leadSheetId: any;
  leadSheetName: string;
  mapSheetId: any;
  mapNo: any;
  dialogRef: any;
  leadSheetData: any;
  leadSheetColumns: string[] = ['leadSheetCode', 'Description'];
  mappingColumns: string[] = ['mapno', 'mapsheetname'];
  selectedEngagementDetails: any;
  isPrevyear: boolean;
  year: number;
  yearEnd: any;
  currentYearIS: any;
  previousYearIS: any;
  isDisplayCol: boolean = false;
  TbLeadSheetId: any;
  tbMapSheetId: any;
  isDisableMoveButton: any;
  private subject: Subject<string> = new Subject();
  headerNotesColumn1 = '';
  headerNotesColumn2: any;
  headerNotesColumn3: any;
  isSecondColumnClicked: boolean;
  isThirdColumnClicked: boolean;
  showPreviousYeardata: boolean;
  connectedTo = [];
  yearEndDetails: any = [];
  engagementId: any;
  clientName: any;
  selectedYearEnd: any;
  selectedYearTitle: string;
  leadsheetdisable: boolean = false;
  duplicateIds = [];
  groupIds = [];
  selectedTrailBLrow: any = [];
  subChildArray: any;
  disableAddGroupButton: boolean = false;
  isindividualRowSave: boolean = true;
  selectedLSmenuPositions = [];
  submoduleId: number;
  lsMenuPopupHeight = 145;
  leadsheetPopupHeight = 535;//380;
  mapNumberPopupHeight = 691;
  changeInValueWRTls = 0;
  changeInValueWRTmap = 0;
  activeMapMove = false;
  initialYaxis = 0;
  activeLsMove = false;
  groupName: string;
  headerData = [];
  footerNote: string;
  isFooterNoteEdited = false;
  oldFooterNote: string;
  disabledGroupButton = false;
  isCheckedAll = false;
  unGroupId: any;
  unGroupName: any;
  addNewElementsList = [];
  selectedAddItemsList = [];
  sortData = [];
  groupisASC: boolean = false;
  amountisASC: boolean = false;
  subGroupSubModuleId: any;
  addPixel = 218;
  sortGroup: string = "AUTO";
  sortArray: any[] = [{ "name": "Automatic", "value": "AUTO" }, { "name": "Manual", "value": "MAN" }];
  isASC: boolean = true;
  sortOrder: boolean;
  isDisableUpArrow: boolean = true;
  isDisableDownArrow: boolean = true;
  manualSortData = [];
  checkedManualData: any = [];
  restrictedColumn: boolean;
  incomeHeaderInfo: any;
  isSearchExist = true;
  addExpensesSaperator: boolean;
  dataPresentation: boolean;
  disableSort = true;
  autoSortApplied = false;
  openingsBalanceValue: any;
  editingTitle = false;
  hideMoveButton = true;
  isyesno: any;
  sortCheckboxLength: number;
  isNetLossHeaderpanel = false;
  openingsBalanceValuePy2: any;
  shortCutMenuDetails: any;
  finSubGroupId: any;
  pageX: any;
  pageY: any;
  finsubgroupchildId: any;
  acl: AclModel;
  searchKeyword: string;
  todayYear: any;
  isHideFooterNotesToFS = false;
  crossCheckValues = {
    currentYear: 0,
    previousYear: 0
  }
  isViewSeparated = false;
  isManualGroupExists = 0;
  firm: FirmModel;
  private destroyRef = inject(DestroyRef);
  public readonly roundingData$: BehaviorSubject<RoundingModel> = new BehaviorSubject<RoundingModel>(null);
  public isHideActionsForPY: boolean = false;
  public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null, SPIN_STYLES.LINE));
  private spinCount: number = 0;

  @HostListener('window:storage', ['$event'])
  onStorageChange(ev: StorageEvent) {
    if (ev.key == 'RetainedEarningStatement') {
      this.isyesno = parseInt(localStorage.getItem('isyesno'))
      if (this.isyesno == 0) {
        this.submoduleId = this.submoduleId == 436 ? this.submoduleId : 436;
      }
      else {
        this.submoduleId = this.submoduleId == 437 ? this.submoduleId : 437;
      }
      localStorage.setItem('workBookSubmoduleId', this.submoduleId.toString());
      this.refreshIncomeStatement();
    }

    if (ev.key == 'refreshWorkBookIS' || ev.key == 'adjustmentEntrySaved') {
      this.refreshIncomeStatement();
      setTimeout(() => {
        this.applySort(true);
      }, 1000);
    }
  }
  trackobj: { engagementsId: any; submoduleId: any; submoduleUuid: any; };
  userActivity;
  userInactiveSub: Subscription;
  userInactive: Subject<any> = new Subject();
  @HostListener('window:mousemove', ["$event"])
  @HostListener('window:resize', ["$event"])
  @HostListener('window:keydown', ["$event"])
  refreshUserState() {
    clearTimeout(this.userActivity);
    if (localStorage.getItem("timerStatus") == "Idle")
      this.trackerService.startTimer("Active");
    this.setTimeout();
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    localStorage.setItem("isOpenWB", "false");
  }

  constructor(private authService: AuthService, private aclService: AclService, private apiService: ApiService,
    private sharedService: SharedService, public dialog: MatDialog, private toastr: ToastrService,
    public datePipe: DatePipe, private trackerService: TimeTrackerService,
    private firmService: FirmService, private router: Router, @Inject(DOCUMENT) private document: Document,
    public workbookservice: WorkbookService, private countableTimeZonePipe: CountableTimeZonePipe, private engservice: EngService,
    private engApiService: EngApiService, private tbApiService: TbApiService) {
    this.setTimeout();
    this.userInactive.subscribe(() => {
      this.trackerService.startTimer("Idle");
    });
  }

  ngOnInit() {
    this.authService.subjectUserDetail.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(detail => {
      this.userData = detail;
    });
    this.aclService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(acl => {
      this.acl = acl;
    });

    this.firmService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(firm => {
      if (firm) {
        this.firm = firm;
      }
    });
    localStorage.removeItem("refreshFinancialStatements-REH");
    localStorage.removeItem("refreshFinancialStatements-RE");
    localStorage.removeItem("refreshFinancialStatements-BSH");
    localStorage.removeItem("refreshFinancialStatements-BS");
    localStorage.removeItem("refreshFinancialStatements-LSG");
    localStorage.removeItem("refreshWorkBookIS");
    this.todayYear = new Date().getFullYear();
    this.incomeHeaderInfo = [];
    this.restrictedColumn = false //need to check with corporation and update the value

    this.engagementData = JSON.parse(localStorage.getItem("selectedEngagementObj"));
    this.selectedEngagementDetails = JSON.parse((localStorage.getItem('selectedEngagementObjCopy')));
    const isTaxEngagement = this.engservice.isTaxTemplate(this.engagementData);
    if (isTaxEngagement) {
      this.submoduleId = 436;
    } else {
      this.submoduleId = JSON.parse(localStorage.getItem('workBookSubmoduleId'));
    }
    this.shortCutMenuDetails = JSON.parse(localStorage.getItem('shortCutMenuDetails'));
    this.accYearEnd = parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y'));
    this.engagementId = this.engagementData.engagementsid;
    this.clientName = this.selectedEngagementDetails.clientName;
    this.trackobj = {
      "engagementsId": this.engagementData.engagementsid,
      "submoduleId": this.submoduleId,
      "submoduleUuid": localStorage.getItem("WUUID"),
    }
    localStorage.setItem("timeTrackerObj", JSON.stringify(this.trackobj));
    this.trackerService.startTimer("Active");
    this.getHeaderTitles(false);
    this.getYearEndDetails();
    this.getFsSettings();
    this.sharedService.isMovingLeadsheet.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res.subscribeFrom === "IS") {
        if (res.moveType === "SINGLE") {
          if (res.moveFrom === "LS") {
            this.confirmSaveLeadsheet(res.parent, res.child, res.yearType);
          } else {
            this.confirmSaveMapNo(res.parent, res.child, res.yearType);
          }
        } else {
          this.isDisableMoveButton = res.isDisableMoveButton;
          if (res.moveFrom === "LS") {
            this.leadSheetDetail(res.child);
          } else {
            this.mapSheetData(res.child);
          }
        }
      }
    })
    this.sharedService.unAssignMapNumber.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res) {
        this.saveUnMappingItems(res);
      }
    });
    this.subject.pipe(
      // if character length greater then 2
      filter(res => res.length > 2 || res.length < 3)
      // Time in milliseconds between key events
      , debounceTime(1000)
      // If previous query is diffent from current
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      this.filterIncomeStatementDetails(text);
    });
    this.sharedService.isBulkMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      if (response === "SINGLE") {
        this.getIncomeStatementDetails(this.searchText);
        this.refreshPreview();
      } else if (response && response !== 'SINGLE') {
        this.clearSelection();
        this.getIncomeStatementDetails(this.searchText);
        this.refreshPreview();
      }
    });
    this.sharedService.leftSideMenuNameChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      if (response) {
        this.getHeaderTitles();
      }
    });
    this.sharedService.hideMoveButton.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      this.hideMoveButton = response != true;
    });
    this.sharedService.sortingPosition.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.addPixel = res ? 218 : 0;
    });
    this.getFSNotes();
  }
  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), idleTime);
  }
  changePosition(event, checkboxLevel) {
    setTimeout(() => {
      const span: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
      if (span != null) {
        const child: HTMLElement = document.querySelector('.cdk-overlay-pane');
        if (child) {
          child.style.left = '0';
          child.style.top = '0';
        }
        let popupSize = !this.activeMapMove && !this.activeLsMove ? this.lsMenuPopupHeight : this.activeMapMove ? this.mapNumberPopupHeight : this.leadsheetPopupHeight;
        span.style.left = (event.x + 20) + 'px';
        if ((document.documentElement.clientHeight - event.screenY - 35) >= popupSize) {
          span.style.top = ((event.pageY + 10) < 0 ? 0 : (event.pageY + 10)) + 'px';
          span.style.bottom = "auto";
        } else {
          span.style.top = ((event.pageY - popupSize) < 0 ? 0 : (event.pageY - popupSize)) + 'px';
          span.style['margin-top'] = 0;
          span.style.top = ((event.pageY - popupSize - 25) < 0 ? 0 : (event.pageY - popupSize - 25)) + 'px';
        }

        if (!checkboxLevel.trialbal) {
          let menuStyles = {
            'left': span.style.left,
            'top': span.style.top,
            'bottom': span.style.bottom,
            'id': checkboxLevel.trailbalanceid,
            'overflow': 'auto'
          }

          let matchFound = false;
          let dialogCenterHeight = '0';
          for (let i = 0; i < this.selectedLSmenuPositions.length; i++) {
            if (this.selectedLSmenuPositions[i].id === checkboxLevel.trailbalanceid) {
              this.selectedLSmenuPositions.splice(i, 1);
              i = this.selectedLSmenuPositions.length;
              matchFound = true;
              this.activeMapMove = false;
              this.activeLsMove = false;
              this.initialYaxis = 0;
            }
          }
          if (matchFound === false && checkboxLevel.checked) {
            this.selectedLSmenuPositions.push(menuStyles);
          }
          else {
            dialogCenterHeight = ((document.documentElement.clientHeight - 220) / 2) - (popupSize / 2) + 220 + 'px';
            span.style.top = dialogCenterHeight;
          }

          let stylesElement = this.selectedLSmenuPositions[this.selectedLSmenuPositions.length - 1];
          if (stylesElement) {
            span.style.top = stylesElement.top;
            span.style.top = matchFound ? dialogCenterHeight : stylesElement.top;
            span.style.left = stylesElement.left;
            span.style.overflow = 'auto';
            //span.style.height = 'calc(100vh - 270px);';
          }
        }
        else {
          if (!checkboxLevel.checked)
            span.style.top = ((document.documentElement.clientHeight - 220) / 2) - (popupSize / 2) + 220 + 'px';
        }
        if (this.activeMapMove) { this.changeInValueWRTmap = parseInt(span.style['top']); }
        if (this.activeLsMove) { this.changeInValueWRTls = parseInt(span.style['top']); }
      }
      const menuDiv: HTMLElement = document.querySelector('#LSMAPDialog');
      if (menuDiv)
        menuDiv.style.display = 'flex';
    }, 200);
  }
  changePosition1(event, checkboxLevel) {

    const span: HTMLElement = document.querySelector('.checkboxDropdown');

    span.style.left = '82px';
    if ((document.documentElement.clientHeight - event.screenY - 300) >= this.lsMenuPopupHeight) {
      span.style.top = (event.pageY - 35) + 'px';
      span.style.bottom = "auto";
    } else {
      span.style.top = ((event.pageY - this.lsMenuPopupHeight - 70) > 300 ? (event.pageY - this.lsMenuPopupHeight - 70) : 300) + 'px';
      span.style['margin-top'] = 0;
    }
    if (checkboxLevel != 'child2') {
      let menuStyles = {
        'left': span.style.left,
        'top': span.style.top,
        'bottom': span.style.bottom,
        'id': checkboxLevel.trailbalanceid,
        'overflow': "auto"
      }
      //if (this.selectedLSmenuPositions.length > 1) {



      /* for (let i = 0; i < this.selectedLSmenuPositions.length; i++) {
        let index = this.selectedLSmenuPositions.indexOf(checkboxLevel.trailbalanceid)
        if (index === -1) {
          this.selectedLSmenuPositions.push(menuStyles);
        } else {
          this.selectedLSmenuPositions.splice(index, 1);
        }
      } */
      let matchFound = false;
      for (let i = 0; i < this.selectedLSmenuPositions.length; i++) {
        if (this.selectedLSmenuPositions[i].id === checkboxLevel.trailbalanceid) {
          this.selectedLSmenuPositions.splice(i, 1);
          i = this.selectedLSmenuPositions.length;
          matchFound = true;
        }
      }
      if (matchFound === false) {
        this.selectedLSmenuPositions.push(menuStyles);
      }

      // this.selectedLSmenuPositions.forEach( (e, index) =>{
      //   if(e.id === checkboxLevel.trailbalanceid){
      //     this.selectedLSmenuPositions.splice(index, 1);
      //   }else {
      //     this.selectedLSmenuPositions.push(menuStyles);
      //   }
      // })
      /* } else {
        this.selectedLSmenuPositions.push(menuStyles);
      } */
      let stylesElement = this.selectedLSmenuPositions[this.selectedLSmenuPositions.length - 1];
      if (stylesElement) {
        span.style.top = stylesElement.top;
        span.style.bottom = stylesElement.bottom;
        span.style.left = stylesElement.left;
      }
    }
  }

  editingTitleCheck(data) {
    if (this.editingTitle === false) {
      this.focusInput();
      data.isEditable = !data.isEditable
      this.editingTitle = true;
    } else {
      this.toastr.warning("Please save the data");
    }
  }
  closeTitleEdit(data) {
    data.isEditable = !data.isEditable
    this.editingTitle = false;
  }

  getYearEndDetails() {
    this.apiService.getEngagementYearDetails(this.engagementId).subscribe(response => {
      // this.spinner.hide();
      if (response) {
        this.yearEndDetails = response;
        this.selectedYearEnd = this.yearEndDetails[0].acctyear;
      }
    }, error => {
      this.toastr.error("Error in getting Year End Details");
    })
  }
  //create leadsheet
  createLeadsheetItem() {
    const dialogRef = this.dialog.open(this.createLeadsheetDialog, {
      panelClass: 'my-dialog-container-class'
    });
  }

  //
  mappingNumber(obj, type) {
    if (this.isindividualRowSaveforIS) {
      if (type == "previous") {
        obj.isMap = true;
        this.tbMapSheetId = obj.prevmapsheetid;
      } else {
        obj.isMap = true;
        this.tbMapSheetId = obj.mapsheetid;
      }
    }
  }

  //
  applyFilterToMapSheet(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.mapNumData.filter = filterValue;
  }

  //filter leadsheet
  applyFilterToLeadSheet(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.leadSheetData.filter = filterValue;
  }
  handleSearch(searchTerm: string) {
    this.subject.next(searchTerm);
  }

  getIncomeStatementDetails(searchTerm) {
    let search = searchTerm ? searchTerm : null;
    let balanceSheetObj = {
      "engagementsid": this.engagementData.engagementsid,
      "acctyear": parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.countableTimeZonePipe.transform(this.engagementData?.yearEnd, 'yyyy', 'UTC')),
      "submoduleid": this.submoduleId,
      "searchtext": search
      //"engagementsid":47
    }
    let finalGetObj = JSON.stringify(balanceSheetObj);
    this.updateSpinnerConfig(true);
    this.engApiService.getWFSIncomeStatement(finalGetObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          let data = JSON.parse(res?.data);
          this.incomeStatementdetails = data.groups;
          this.originalIncomeStatementdetails = data.groups;
          if (data?.groups && data.groups.length) {
            const crossCheckData = data.groups;
            crossCheckData.slice(-2).forEach((p, i) => {
              if (i === 0) {
                if (p?.Currgrouptotal && p.Currgrouptotal === '-') {
                  this.crossCheckValues.currentYear = 0;
                } else {
                  this.crossCheckValues.currentYear = p?.Currgrouptotal ? (p.Currgrouptotal.includes('(') ? Number(-p.Currgrouptotal.replace(/[(,)]/g, '')) : Number(+p.Currgrouptotal.replace(/[(,)]/g, ''))) : 0;
                }
              } else if (i === 1) {
                if (p?.Prevgrouptotal && p.Prevgrouptotal === '-') {
                  this.crossCheckValues.previousYear = 0;
                } else {
                  this.crossCheckValues.previousYear = p?.Prevgrouptotal ? (p.Prevgrouptotal.includes('(') ? Number(-p.Prevgrouptotal.replace(/[(,)]/g, '')) : Number(+p.Prevgrouptotal.replace(/[(,)]/g, ''))) : 0;
                }
              }
            });
          }
          this.restrictedColumn = data.isnotesshow == 1 ? true : false;
          this.isSearchExist = data.searchexist == 1 ? true : false;
          this.openingsBalanceValue = data.vopeinginbalancevalue;
          this.openingsBalanceValuePy2 = data.vopeinginbalancevaluepy2;
          this.defaultDragging();
          var prev = this.incomeStatementdetails[0]['Prevgrouptotal'];
          this.getPreviousAndCurrentDate();
          this.isPrevyear = !!(prev || prev == 0);
          this.showRoundingDifference(data);
        } else {
          this.toastr.warning('Failed to income statement');
        }
      }, error: e => {
        this.toastr.warning(e.error);
      }
    })
  }

  showRoundingDifference(incomeStatement: any) {
    const roundingViewData = this.sharedService.showRoundingDifference(incomeStatement)
    this.roundingData$.next(roundingViewData);
  }

  defaultDragging() {
    this.dataPresentation = false;
    this.addExpensesSaperator = false;
    this.connectedTo = [];
    this.incomeStatementdetails.forEach(p => {
      if (p.id === 5) {
        this.dataPresentation = true;
      }
      if (p.id === '4.5.3') {
        this.addExpensesSaperator = true;
      }
      if (p.trialbal != undefined) {
        this.connectedTo.push(p.id + '');
      }
      else {
        p.isexpand = true;
      }
      if (p.children == undefined) {
        p.isexpand = true;
      }
      if (p.id === 4 || p.id === 5 || p.id === 6 || p.id == '6.37.00' || p.id === 10) {
        if (p.children) {
          p.children.forEach(s => {
            if (s.children) {
              s.children.forEach(sc => {
                this.connectedTo.push(sc.id + '');
                if (sc.trialbal) {
                  sc.trialbal.forEach(ssc => {
                    ssc.isDraggable = true;
                  })
                }
              });
            }
          });
        }
      }
    });
  }
  //refresh Balance sheet
  refreshIncomeStatement() {
    this.editingTitle = false;
    this.selectedLSTrailBLrow = [];
    this.isindividualRowSaveforIS = true;
    this.refreshPreview();
    this.getHeaderTitles();
    this.getFsSettings();
    // this.getIncomeStatementDetails(this.searchText);
    this.duplicateIds = [];
    this.groupIds = [];
    this.multipleMoveMenu.closeMenu();
    this.isHideActionsForPY = this.selectedYearEnd != this.accYearEnd;
    if (this.isHideActionsForPY) {
      this.isPreviousYear();
    }
    localStorage.removeItem('refreshWorkBookIS');
    localStorage.removeItem('adjustmentEntrySaved');
    this.isDisplayCol = false;
    console.log("valueschange", this.isDisplayCol, this.isPrevyear)
  }

  refreshPreview() {
    const filterDate = structuredClone(this.yearEndDetails.filter(e => e.acctyear === this.selectedYearEnd));
    if (filterDate && filterDate.length) {
      localStorage.setItem('workbookChangeYearEnd', this.countableTimeZonePipe.transform(filterDate[0].acctdate, 'YYYY-MM-DD', 'UTC'));
    }
    this.getPreviousAndCurrentDate();
    localStorage.setItem('isLastYear', (this.yearEndDetails[this.yearEndDetails.length - 1].acctyear === this.selectedYearEnd) ? 'true' : 'false')

    localStorage.setItem('workbookChangeDate', this.selectedYearEnd);
    this.getHeaderTitles();
    this.sharedService.refreshWorkbookmenu.next(true);
    let obj = {
      "currentYear": parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.datePipe.transform(this.engagementData.yearEnd, 'y')),
      "isRefresh": true
    }
    localStorage.setItem('refreshFinancialStatements-IS', "success");
    localStorage.setItem('refreshTrialbalance', "success");
    // this.sharedService.TSselectedYear.next(obj);
    const message = DocumentPreviewTypes.INCOME_STATEMENT;
    window.opener.postMessage(message, '*');
    const refreshMap = this.sharedService.setRefreshOfStatement(DocumentPreviewTypes.INCOME_STATEMENT);
    this.sharedService.updateFinStatement$.next(refreshMap);
  }

  // check box
  checkChange(checkeditem, completeObj, subGroupId, groupData) {
    this.isManualGroupExists = 0;
    if (completeObj && completeObj?.isuseradded) {
      this.isManualGroupExists = completeObj.isuseradded;
    }
    this.duplicateIds = [];
    if (completeObj.trialbal) {
      var objcount = completeObj.trialbal.length;
      this.subChildArray = completeObj;
      var count = 0;
      completeObj.trialbal.map(b => {
        if (b.checked == true) {
          count = count + 1;
        }
        else {
          count = count - 1;
        }
      });
      if (objcount == count) {
        completeObj.checked = true;
      } else {
        completeObj.checked = false;
      }
    }
    if (checkeditem.checked == true) {
      let idsSet = [];
      if (subGroupId != 'otherIncomes') {
        checkeditem.subGroupId = subGroupId;
      } else {
        let ids = completeObj.chldid.split('.');
        checkeditem.subGroupId = ids[1];
      }
      checkeditem.groupId = groupData ? groupData.id : '';
      if (completeObj.id)
        idsSet = completeObj.chldid.split('.');
      this.groupIds.push(idsSet[1]);
      this.selectedLSTrailBLrow.push(checkeditem);
    }
    else {
      this.selectedLSTrailBLrow.map((x, index) => {
        if (x.trailbalanceid == checkeditem.trailbalanceid) {
          this.selectedLSTrailBLrow.splice(index, 1);
        }
      })
      if (this.groupIds) {
        let idsSet = [];
        // this.groupIds.map((e, index) => {
        //   idsSet = completeObj.chldid.split('.');
        //   if (e == idsSet[1]) {
        //     this.groupIds.splice(index, 1);
        //   }
        // })
        for (var i = 0; i < this.groupIds.length; i++) {
          idsSet = completeObj.chldid.split('.');
          if (this.groupIds[i] == idsSet[1]) {
            this.groupIds.splice(i, 1);
            i = this.groupIds.length;
          }
        }
      }

    }
    //removing duplicates
    for (let i = 0; i < this.groupIds.length; i++) {
      if (this.duplicateIds.indexOf(this.groupIds[i]) === -1) {
        this.duplicateIds.push(this.groupIds[i]);
      }
    }
    if (this.duplicateIds.length > 1) {
      this.disableAddGroupButton = true;
    }
    else {
      this.disableAddGroupButton = false;
    }
    var unmappedcount = 0
    this.selectedLSTrailBLrow.map(d => {
      if (d.mapsheetid == 0) {
        unmappedcount = unmappedcount + 1
      }
    });
    //this.multipleUnmappedMoveMenu.closeMenu();
    // for unmapped selection
    if (unmappedcount > 0 && this.duplicateIds.length > 0) {
      this.leadsheetdisable = true;
      //this.multipleUnmappedMoveMenu.openMenu();
    }
    else if (unmappedcount > 0) {
      this.leadsheetdisable = true;
      //this.multipleUnmappedMoveMenu.closeMenu();
    }
    else {
      this.leadsheetdisable = false;
    }
    this.multipleMoveMenu.closeMenu();
    //for enable map no and leadsheet selection
    if (this.selectedLSTrailBLrow.length > 0) {
      this.multipleMoveMenu.openMenu();
      const menuDiv: HTMLElement = document.querySelector('#LSMAPDialog');
      if (menuDiv)
        menuDiv.style.display = 'none';

    } else {
      const parent: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
      if (parent != null) {
        parent.style['margin-top'] = 0;
      }
      this.selectedLSmenuPositions = [];
      this.isDisableMoveButton = true;
      this.activeMapMove = false;
      this.activeLsMove = false;
      this.multipleMoveMenu.closeMenu();
    }
    if (this.selectedLSTrailBLrow.length > 0) {
      this.isindividualRowSaveforIS = false;
    } else {
      this.isindividualRowSaveforIS = true;
      this.disableLsAndMapNo();
    }
    if (this.selectedLSTrailBLrow.length == 1) {
      this.enableOrDisableDragging(true);
    } else {
      this.enableOrDisableDragging(false);
    }
  }

  enableOrDisableDragging(value: boolean) {
    this.incomeStatementdetails.forEach(p => {
      if (p.id === 4 || p.id === 5 || p.id === 6) {
        p.children.forEach(s => {
          if (s.children) {
            s.children.forEach(sc => {
              if (sc.trialbal) {
                sc.trialbal.forEach(ssc => {
                  if (ssc.checked && value) {
                    ssc.isDraggable = value;
                  } else {
                    ssc.isDraggable = value;
                  }

                })
              }
            });
          }
        });
      }
    });
  }
  disableLsAndMapNo() {
    this.incomeStatementdetails.forEach(p => {
      if (p.id === 4 || p.id === 5 || p.id === 6) {
        p.children.forEach(s => {
          s.isMap = false;
          if (s.children) {
            s.children.forEach(sc => {
              if (sc.trialbal) {
                sc.trialbal.forEach(ssc => {
                  ssc.isLeadSheet = false;
                  ssc.isMap = false;
                })
              }
            });
          }
        });
      }
    });
  }
  subGroupCheckChange(subGroupData, groupData) {
    this.isManualGroupExists = 0;
    if (subGroupData && subGroupData?.isuseradded) {
      this.isManualGroupExists = subGroupData.isuseradded;
    }
    this.duplicateIds = [];
    if (subGroupData.checked == true) {
      if (subGroupData.trialbal) {
        subGroupData.trialbal.map(x => {
          if (x.checked) {
            if (x.checked != true) { //if item is not available in obj then push
              x.checked = true
              this.selectedLSTrailBLrow.push(x);
              this.groupIds.push(subGroupData.id);
            }
          } else {
            x.checked = true
            this.selectedLSTrailBLrow.push(x);
            this.groupIds.push(subGroupData.id);
          }
        })
      }
    }
    else {
      subGroupData.trialbal.map((y, i) => {
        y.checked = false
        this.selectedLSTrailBLrow.map((b, index) => {
          if (y.trailbalanceid == b.trailbalanceid) {
            this.selectedLSTrailBLrow.splice(index, 1);
            this.groupIds.splice(index, 1);
          }
        })
      })
    }
    for (let i = 0; i < this.groupIds.length; i++) {
      if (this.duplicateIds.indexOf(this.groupIds[i]) === -1) {
        this.duplicateIds.push(this.groupIds[i]);
      }
    }
    if (this.duplicateIds.length > 1) {
      this.disableAddGroupButton = true;
    }
    else {
      this.disableAddGroupButton = false;
    }
    this.multipleMoveMenu.closeMenu();
    //for enable/disable map no and leadsheet selection
    if (this.selectedLSTrailBLrow.length > 1) {
      //this.isMove = true
      this.multipleMoveMenu.openMenu();
      const menuDiv: HTMLElement = document.querySelector('#LSMAPDialog');
      menuDiv.style.display = 'none';
    } else {
      //this.isMove = false
      this.multipleMoveMenu.closeMenu();
    }
    if (this.selectedLSTrailBLrow.length > 0) {
      this.isindividualRowSaveforIS = false
    } else {
      this.isindividualRowSaveforIS = true
    }
    if (this.selectedLSTrailBLrow.length == 1) {
      this.enableOrDisableDragging(true);
    }
    else {
      this.enableOrDisableDragging(false);
    }
  }
  radioChange(event) {
    var val = event.value;
    if (val == "Leadsheet") {
      this.isLeadSheet = true
    }
    if (val == "MapNo") {
      this.isLeadSheet = false
    }
  }

  //lead sheet details
  leadSheetDetail(value) {
    this.leadSheetId = value.leadsheetid
  }
  // confirm save map no
  confirmSaveMapNo(value, MapSheet, yearType: "PREVIOUS" | "CURRENT") {
    this.mapNo = MapSheet.mapno;
    this.mapSheetId = MapSheet.mastermapsheetid;
    let trialbalanceId = yearType === "PREVIOUS" ? value.prevtrailbalanceid : value.trailbalanceid;
    let mapsheetId = yearType === "PREVIOUS" ? value.prevmapsheetid : value.mapsheetid;
    this.selectedLSTrailBLrow = [];
    var mapSheetObj = {
      "accountname": value.accountname,
      "leadsheet": value.leadsheet,
      "leadsheetid": value.leadsheetid,
      "mapno": value.mapno,
      "mapsheetid": value.mapsheetid,
      "trailbalanceid": trialbalanceId
    }
    this.selectedLSTrailBLrow.push(mapSheetObj)
    this.dialog.open(this.saveMapNoalertforIS, { disableClose: true });
    // this.dialogRef.afterClosed().subscribe(result => {
    // });
  }
  onChangeSort(event) {
    this.manualSortData = [];
    this.sortData.map(e => {
      e.checked = false;
    })
  }
  mapSheetData(value) {
    this.mapSheetId = value.mastermapsheetid;
  }
  savemappingdetails() {
    let mapdetails = [];
    if (this.selectedLSTrailBLrow) {
      this.selectedLSTrailBLrow.map(x => {
        mapdetails.push({
          "trailbalanceid": x.trailbalanceid,
          "mapsheetid": this.mapSheetId,
          "loginid": this.userData['useracctid'],
          "acctyear": parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.datePipe.transform(this.engagementData.yearEnd, 'y'))
        })
      })
    }
    let MappingObj = {
      "tbmapping": mapdetails
    }
    let finalSaveMappingObj = JSON.stringify(MappingObj);
    this.updateSpinnerConfig(true);
    this.tbApiService.saveNewTbMapping(finalSaveMappingObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.toastr.success('Map No. moved successfully');
          this.refreshPreview();
          this.sharedService.sendNotifySubject.next({ 'uuid': this.userData.useracctid, 'isfirm': 1 });
          this.selectedLSTrailBLrow = [];
          this.mapSheetId = '';
          this.isMoveforIS = false;
          this.getIncomeStatementDetails(this.searchText);
          this.isindividualRowSaveforIS = true;
          this.multipleMoveMenu.closeMenu();
          this.clearSelection();
        } else {
          this.toastr.success('Failed to move mapping');
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  clearSelection() {
    const parent: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (parent != null) {
      parent.style['margin-top'] = 0;
    }
    this.changeInValueWRTmap = 0;
    this.changeInValueWRTls = 0;
    this.initialYaxis = 0;
    this.groupName = "";
    this.clearSelectedData();
    this.hideMoveButton = true;
    this.incomeStatementdetails.map(x => {
      if (x.children) {
        x.children.map(y => {
          if (y.children) {
            y.children.map(z => {
              if (z.trialbal) {
                z.trialbal.map(a => {
                  if (a.checked == true) {
                    a.checked = false;
                    a.isMap = false;
                    a.isLeadSheet = false;
                  }
                })
                if (z.checked == true) {
                  z.checked = false;
                  z.isMap = false;
                  z.isLeadSheet = false;
                }
              }
            })
          }
          else {
            if (y.checked == true) {
              y.checked = false;
            }
          }
        })
      }
    })
    this.multipleMoveMenu.closeMenu();
  }
  clearSelectedData() {
    this.groupIds = [];
    this.duplicateIds = [];
    this.selectedLSTrailBLrow = [];
    this.selectedLSmenuPositions = [];
    this.isDisableMoveButton = true;
    this.activeMapMove = false;
    this.activeLsMove = false;
    this.leadsheetdisable = false;
    this.isindividualRowSaveforIS = true;
  }
  //confirm save lead sheet details
  confirmSaveLeadsheet(value, LSData, yearType: "PREVIOUS" | "CURRENT") {
    this.leadSheetId = LSData.leadsheetid;
    let trialbalanceId = yearType === "PREVIOUS" ? value.prevtrailbalanceid : value.trailbalanceid;
    let mapsheetId = yearType === "PREVIOUS" ? value.prevmapsheetid : value.mapsheetid;
    this.leadSheetName = LSData.leadsheetcode + "-" + LSData.leadsheetname;
    this.selectedLSTrailBLrow = [];
    var leadSheetObj = {
      "accountname": value.accountname,
      "leadsheet": value.leadsheet,
      "leadsheetid": value.leadsheetid,
      "mapno": value.mapno,
      "mapsheetid": mapsheetId,
      "trailbalanceid": trialbalanceId
    }
    this.selectedLSTrailBLrow.push(leadSheetObj)
    this.dialogRef = this.dialog.open(this.saveLeadsheetalertforIS, { disableClose: true });
  }

  //save leadsheet details
  saveLeadSheetdetails() {
    var mapdetails = []
    if (this.selectedLSTrailBLrow) {
      this.selectedLSTrailBLrow.map(x => {
        mapdetails.push({
          "trailbalanceid": x.trailbalanceid,
          "leadsheetid": this.leadSheetId, "mastermapsheetid": x.mapsheetid, "loginid": this.userData['useracctid'],
          "submoduleid": this.submoduleId, "fsid": 0
        })
      })
    }
    var leadSheetObj = {
      "leadsheetchange": mapdetails
    }
    var finalSaveMappingObj = JSON.stringify(leadSheetObj)
    this.updateSpinnerConfig(true);
    this.engApiService.saveBsIsLeadSheetGrouping(finalSaveMappingObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.toastr.success('Leadsheet moved successfully');
          this.refreshPreview();
          this.leadSheetId = '';
          this.getIncomeStatementDetails(this.searchText);
          this.clearSelectedData();
          this.multipleMoveMenu.closeMenu();
        } else {
          this.toastr.error('Failed to move Lead Sheet');
          this.getIncomeStatementDetails(this.searchText);
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  UpdateIncomeStatementTitle(objchild, type) {
    var obj = {
      "engagementsid": this.engagementData.engagementsid,
      //"acctyear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
      "acctyear": parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.datePipe.transform(this.engagementData.yearEnd, 'y')),
      "fsid": objchild.chldid,
      "fstype": "incomeStatement",
      "currentname": objchild.oldvalue,
      "newname": objchild.name,
      "ploginid": this.userData.useracctid
    }
    this.apiService.saveFsDetails(obj).subscribe(response => {
      if (response) {
        this.toastr.success("Group name updated successfully");
        this.refreshPreview();
        this.getIncomeStatementDetails(this.searchText);
        this.editingTitle = false;
      }
      else {
        this.toastr.warning("Failed to update group name");
      }
    }, error => {
      this.toastr.error(error.error)
    })

  }

  groupDialog() {
    this.dialog.open(this.GroupDialogBox);
    this.dialogRef.afterClosed().subscribe(result => {
    });
  }

  isPreviousYear() {
    this.isDisplayCol = !this.isDisplayCol;
  }

  activeLSDropdown(obj, type) {
    if (this.isindividualRowSaveforIS) {
      if (type === 'previous') {
        obj.isLeadSheet = true;
        this.TbLeadSheetId = obj.prevleadsheetid;
      } else {
        obj.isLeadSheet = true;
        this.TbLeadSheetId = obj.leadsheetid;
      }
    }
  }

  saveUnMappingItems(data) {
    let trialbalanceId = data.yearType === "PREVIOUS" ? data.parent.prevtrailbalanceid : data.parent.trailbalanceid;
    let inputObject = [{
      "trailbalanceid": trialbalanceId,
    }]
    var finalSaveMappingObj = JSON.stringify({
      "unmapping": inputObject
    })

    this.updateSpinnerConfig(true);
    this.tbApiService.unMap(finalSaveMappingObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res.data) {
          this.toastr.success('Unmapped successfully');
          this.refreshPreview();
          this.getIncomeStatementDetails(this.searchText);
        } else {
          this.toastr.error('Unmapping failed');
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  drop(event: CdkDragDrop<any[]>, data) {
    let obj = {};
    let dropedleadsheetId = 0;
    dropedleadsheetId = event.container.data[0].leadsheetid;
    let fid: any;
    if (data.isuseradded === 1) {
      let ids = data.chldid.split('.', 2);
      fid = ids[0] + "." + ids[1];
    } else {
      fid = '0';
    }
    if (event.previousContainer !== event.container) {
      const leadsheetId = event.container.data[0].leadsheetid;
      const mapsheetId = event.container.data[0].mapsheetid;
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      let fid: any;
      if (data.isuseradded === 1) {
        let ids = data.chldid.split('.', 2);
        fid = ids[0] + "." + ids[1];
      } else {
        fid = '0';
      }
      obj = {
        trailbalanceid: event.item.data.trailbalanceid,
        leadsheetid: leadsheetId,
        mastermapsheetid: mapsheetId,
        loginid: this.userData['useracctid'],
        fsid: fid,
        submoduleid: this.submoduleId
      }
      this.saveDraggingItem(obj);
    }
  }

  saveHeaderNote() {
    const headerNameModel: HeaderNameModel = {
      subModuleId: this.submoduleId,
      engId: this.engagementId,
      changedNameLine2: this.headerNotesColumn2,
      changedNameLine3: this.headerNotesColumn3,
      isDelete: 0
    }

    this.updateSpinnerConfig(true);
    this.workbookservice.saveChangeWbHeaderName(headerNameModel).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.toastr.success('Header Details Updated Successfully');
          this.isSecondColumnClicked = false;
          this.isThirdColumnClicked = false;
          this.getHeaderTitles();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  activeMultiLs(obj, event) {
    obj.isLeadSheet = true;
    this.TbLeadSheetId = 0;
    this.isDisableMoveButton = true;
    this.hideMoveButton = true;
    const span: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (this.initialYaxis === 0) {
      this.initialYaxis = event.clientY;
    }
    if (!this.activeMapMove && !this.activeLsMove) {
      if ((document.documentElement.clientHeight - this.initialYaxis - 35) <= this.leadsheetPopupHeight) {
        span.style['top'] = -(this.leadsheetPopupHeight - (document.documentElement.clientHeight - this.initialYaxis) - 20) + 'px';
        if (parseInt(span.style['top']) < 0)
          span.style['top'] = "0px";

        span.style['height'] = (this.mapNumberPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.mapNumberPopupHeight :
          this.leadsheetPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.leadsheetPopupHeight :
            (document.documentElement.clientHeight - parseInt(span.style['top']))) + "px";
      }
    } else {
      if (this.activeLsMove)
        span.style['top'] = this.changeInValueWRTls + "px";
      else
        span.style['top'] = this.changeInValueWRTmap + "px";
    }
    this.changeInValueWRTls = parseInt(span.style['top']);
    this.activeLsMove = true;
    this.activeMapMove = false;
    span.style['overflow'] = "auto";
  }
  activeMultiMapNo(obj, event) {
    obj.isMap = true;
    this.tbMapSheetId = 0;
    this.isDisableMoveButton = true;
    this.hideMoveButton = true;
    const span: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (this.initialYaxis === 0) {
      this.initialYaxis = event.clientY;
    }
    if (!this.activeMapMove && !this.activeLsMove) {
      if ((document.documentElement.clientHeight - this.initialYaxis - 35) <= this.mapNumberPopupHeight) {
        span.style['top'] = parseInt(span.style['top']) - (this.mapNumberPopupHeight - (document.documentElement.clientHeight - this.initialYaxis) - 20) + 'px';
        if (parseInt(span.style['top']) < 0)
          span.style['top'] = "0px";
        span.style['height'] = (this.mapNumberPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.mapNumberPopupHeight :
          this.leadsheetPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.leadsheetPopupHeight :
            (document.documentElement.clientHeight - parseInt(span.style['top']))) + "px";
      }
    } else {
      if (this.activeMapMove)
        span.style['top'] = this.changeInValueWRTmap + "px";
      else
        span.style['top'] = this.changeInValueWRTls + "px";
    }
    this.changeInValueWRTmap = parseInt(span.style['top']);
    this.activeMapMove = true;
    this.activeLsMove = false;
    span.style['overflow'] = "auto";
  }

  getHeaderTitles(isSetKey?: boolean) {
    this.workbookservice.getWbHeaderNote(this.engagementId, this.submoduleId).subscribe({
      next: res => {
        if (res?.status === 200 && res?.data) {
          const results = JSON.parse(res.data);
          this.headerData = results;
          this.headerNotesColumn1 = results[0].header[0].changednameline1;
          this.headerNotesColumn2 = results[0].header[0].changednameline2;
          this.headerNotesColumn3 = results[0].header[0].changednameline3;
          this.footerNote = results[1].note ? results[1].note[0].note : "";
          if (isSetKey == undefined) {
            localStorage.setItem('refreshFinancialStatements-ISH', "success");
          }
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  saveDraggingItem(obj) {
    let leadSheetObj = {
      "leadsheetchange": []
    }
    leadSheetObj.leadsheetchange.push(obj);
    let finalSaveMappingObj = JSON.stringify(leadSheetObj);
    this.updateSpinnerConfig(true);
    this.engApiService.saveBsIsLeadSheetGrouping(finalSaveMappingObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.toastr.success('Account moved successfully');
          this.refreshPreview();
          this.getIncomeStatementDetails(this.searchText);
          this.isindividualRowSaveforIS = true;
        } else {
          this.toastr.error('Failed to move leadsheet');
          this.refreshPreview();
          this.getIncomeStatementDetails(this.searchText);
        }
      }, error: e => {
        this.getIncomeStatementDetails(this.searchText);
        this.toastr.error(e.error);
      }
    });
  }

  saveFooterNote() {
    this.footerNote = this.footerNote.trim();
    if (!this.footerNote) {
      this.toastr.warning("Please enter the notes");
      return;
    }
    if (this.footerNote.length > 250) {
      this.toastr.warning("Text length is limited to 250 characters");
      return;
    }

    localStorage.removeItem('isfooterUpdated');

    const wbNoteModel: WbNoteModel = {
      subModuleId: this.submoduleId,
      engId: this.engagementId,
      note: this.footerNote,
      isDelete: 0
    };
    this.updateSpinnerConfig(true);
    this.workbookservice.saveWbNote(wbNoteModel).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.sharedService.isIncomeStatementFooterUpdate.next({ 'isfooterUpdated': true, 'note': this.footerNote });
          localStorage.setItem('isfooterUpdated', this.footerNote);
          this.toastr.success('Footer Details Updated Successfully');
          this.isFooterNoteEdited = false;
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  editFooterNotes() {
    this.focusInput();
    this.oldFooterNote = this.footerNote;
    this.isFooterNoteEdited = true;
  }

  cancelEditFooterNote() {
    this.footerNote = this.oldFooterNote
    this.isFooterNoteEdited = false;
  }

  focusInput() {
    setTimeout(() => {
      this.focusInputField.nativeElement.focus();
    }, 0);
  }

  removeChildItem(obj) {
    let count = this.selectedLSTrailBLrow.length;
    let checkedLength = this.selectedLSTrailBLrow.filter(e => e.checked === true);
    if (checkedLength.length == 0) {
      this.disabledGroupButton = true;
    }
    else {
      this.disabledGroupButton = false;
    }
    if (checkedLength.length == count) {
      this.isCheckedAll = true;
    }
    else {
      this.isCheckedAll = false;
    }
    this.backgroundToggle();
  }

  openGroupPopup() {
    this.groupName = '';
    this.isCheckedAll = true;
    const dialogRef = this.dialog.open(this.GroupDialogBox, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => { this.isManualGroupExists = 0; });
  }

  toggleLineItems(event) {
    this.selectedLSTrailBLrow.forEach(e => {
      if (event.checked === true) {
        e.checked = true;
        this.disabledGroupButton = false;
      }
      else {
        e.checked = false;
        this.disabledGroupButton = true;
      }
    });
    this.backgroundToggle();
  }
  backgroundToggle() {
    let trailBalfalseArray = [], trailBalTrueArray = [], tbCount;
    this.incomeStatementdetails.forEach(p => {
      if (p.children) {
        p.children.forEach(c => {
          if (c.children) {
            c.children.forEach(sc => {
              tbCount = sc.trialbal.length;
              trailBalfalseArray = sc.trialbal.filter(e => e.checked == false)
              if (tbCount == trailBalfalseArray.length) {
                sc.checked = false;
              }
              trailBalTrueArray = sc.trialbal.filter(e => e.checked == true)
              if (tbCount == trailBalTrueArray.length) {
                sc.checked = true;
              }
            })
          }
        })
      }
    })
  }
  createGroup() {
    let lineItemArray = [];
    this.selectedLSTrailBLrow.filter(e => {
      if (e.checked == true) {
        let lineItemObj = {
          "trailbalanceid": e.trailbalanceid,
          "sourcegroupid": e.groupId,
          "sourcesubgroupid": e.subGroupId,
          "sourcemapsheetid": e.mapsheetid,
          "sourceleadsheetid": e.leadsheetid,
          "isdelete": 0
        };
        lineItemArray.push(lineItemObj);
      }
    })
    const inputObj = {
      "group": [
        {
          "engagementsid": this.engagementId,
          "submoduleid": this.submoduleId, //need to dynamic
          "acctyear": parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.datePipe.transform(this.engagementData.yearEnd, 'y')),
          "groupname": this.groupName,
          "isdelete": 0,
          "loginid": this.userData['useracctid']
        }
      ],
      "groupitems": lineItemArray
    }
    const stringifyObj = JSON.stringify(inputObj);
    this.updateSpinnerConfig(true);
    this.workbookservice.saveWbCreateGroup(stringifyObj)
      .pipe(tap(res => res.status === 200 && this.refreshPreview()),
        finalize(() => this.updateSpinnerConfig(false)))
      .subscribe({
        next: res => {
          if (res.status === 200) {
            this.selectedLSTrailBLrow = [];
            this.groupIds = [];
            this.duplicateIds = [];
            this.multipleMoveMenu.closeMenu();
            this.isindividualRowSave = true;
            this.clearSelectedData();
            this.refreshPreview();
            this.getIncomeStatementDetails(this.searchText);
            this.toastr.success('Group created successfully');
          }
        }, error: e => {
          this.selectedLSTrailBLrow = [];
          this.groupIds = [];
          this.duplicateIds = [];
          this.multipleMoveMenu.closeMenu();
          this.toastr.error(e.error);
        }
      });
  }
  openunGroupPopup(obj) {
    let groupId;
    this.unGroupName = obj.name;
    groupId = obj.chldid.split('.');
    this.unGroupId = groupId[1];
    const dialogRef = this.dialog.open(this.UngroupDialog, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => { });
  }

  unGroup() {
    const ungroupModel: UngroupModel = {
      engId: this.engagementId,
      subModuleId: this.submoduleId,
      year: parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.datePipe.transform(this.engagementData.yearEnd, 'y')),
      bsIsSubGroupId: this.unGroupId
    };
    this.updateSpinnerConfig(true);
    this.tbApiService.unGroup(ungroupModel)
      .pipe(tap(res => res && this.refreshPreview()),
        finalize(() => this.updateSpinnerConfig(false)))
      .subscribe({
        next: res => {
          if (res?.status === 200 && res?.data) {
            this.toastr.success('Ungrouped successfully');
            this.refreshPreview();
            this.getIncomeStatementDetails(this.searchText);
            this.clearSelectedData();
          }
        }, error: e => {
          this.toastr.error(e.error);
        }
      });
  }
  addgroupDialog(data, subgroupId, parentdata) {
    this.selectedAddItemsList = [];
    this.addNewElementsList = [];
    let dataProcessObject = [];
    let parentId = [];
    data.trialbal.forEach(element => {
      let idsArrow = element.chldid.split('.');
      let obj = {
        "id": idsArrow[idsArrow.length - 1],
        "pgroupId": idsArrow[1]
      };
      let matchFound = false;
      parentId.forEach(element => {
        if (element.id === obj.id) {
          matchFound = true;
        }
      });
      if (matchFound === false) {
        parentId.push(obj)
      }
    })
    //  parentId = idsArrow[idsArrow.length - 1];
    // let groupId = idsArrow[1]
    this.incomeStatementdetails.forEach(element => {
      if (element.children) {
        element.children.forEach(child => {
          if (child.children) {
            child.children.forEach(subChild => {
              parentId.forEach(pId => {
                if (subChild.id === pId.id) {
                  subChild['pgroupId'] = pId.pgroupId;
                  dataProcessObject.push(subChild);
                }
              })
            })
          }
        })
      }
    })
    dataProcessObject.forEach(trial => {
      trial.trialbal.forEach(element => {
        element['sourceGroupId'] = parentdata.id;
        element['subGroupId'] = subgroupId;
        element['groupid'] = trial.pgroupId;
        this.addNewElementsList.push(element);
      })
    })
    this.dialog.open(this.AddgroupDialog);
    //this.dialogRef.afterClosed().subscribe(result => { });
  }

  addNewSelectedItem(data) {
    if (this.selectedAddItemsList.length == 0) {
      this.selectedAddItemsList.push(data)
    } else {
      // trailbalanceid
      let ind = -1;
      this.selectedAddItemsList.forEach((e, index) => {
        if (e.trailbalanceid === data.trailbalanceid) {
          ind = index;
        }
      })
      // let ind = this.selectedAddItemsList.indexOf(data.trailbalanceid);
      if (ind === -1) {
        this.selectedAddItemsList.push(data)
      } else {
        this.selectedAddItemsList.splice(ind, 1);
      }
    }
  }
  submitSelectedAddItems() {
    let lineItemArray = {
      "groupitems": []
    };
    this.selectedAddItemsList.forEach(e => {
      const inputObj = {
        "groupid": e.groupid,
        "trailbalanceid": e.trailbalanceid,
        "sourcegroupid": e.sourceGroupId,
        "sourcesubgroupid": e.subGroupId,
        "sourcemapsheetid": e.mapsheetid,
        "sourceleadsheetid": e.leadsheetid,
        "isdelete": 0
      }
      lineItemArray.groupitems.push(inputObj);
      //groupitems

    });
    const stringifyObj = JSON.stringify(lineItemArray);
    this.updateSpinnerConfig(true);
    this.workbookservice.saveWbAddItem(stringifyObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        this.selectedAddItemsList = [];
        this.refreshPreview();
        this.getIncomeStatementDetails(this.searchText);
        this.clearSelectedData();
        this.toastr.success('Added successfully');
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  enableDeletSeletedItem(parent) {
    let matchfound = false;
    setTimeout(() => {
      parent.trialbal.forEach(e => {
        if (e.checked === true) {
          matchfound = true;
        }
      });
      if (matchfound) {
        parent['deleteSelectItem'] = true;
      } else {
        parent['deleteSelectItem'] = false;
      }
    }, 1000);
  }
  deleteSelectedItems(data) {

    let lineItemArray = {
      "groupitems": []
    };
    let groupId = data.chldid.split('.');
    data.trialbal.forEach(e => {
      if (e.checked === true) {
        const inputObj = {
          "groupid": groupId[1],
          "trailbalanceid": e.trailbalanceid,
          "isdelete": 1
        }
        lineItemArray.groupitems.push(inputObj);
      }
      //groupitems

    });
    const stringifyObj = JSON.stringify(lineItemArray);
    this.workbookservice.deleteWbGroupItem(stringifyObj).subscribe({
      next: res => {
        this.toastr.success('Removed successfully');
        this.refreshPreview();
        this.getIncomeStatementDetails(this.searchText);
      }
    })
  }

  expandAndCollapse(type) {
    let mode = false;
    if (type === 'expand') {
      mode = true;
    } else {
      mode = false;
    }
    this.isincomeStatementExpanded = mode;
    this.incomeStatementdetails.forEach(element => {
      element.isexpand = mode;
      if (element.children) {
        element.children.forEach(child => {
          child.isexpand = mode;
          if (child.children) {
            child.children.forEach(subchild => {
              subchild.isexpand = mode;
            })
          }
        })
      }
    })
  }

  showTotalScore(item) {
    item.isexpand = !item.isexpand;
  }
  mouseEnterHandler(event: MouseEvent, chapterExpansionPanel: MatExpansionPanel) {
    if (event.buttons && !chapterExpansionPanel.expanded) {
      chapterExpansionPanel.open();
    }
  }
  netLossHeaderpanel(data) {
    if (data.children === undefined && data.trialbal === undefined) {
      this.isNetLossHeaderpanel = true;
    }
  }

  // Saving the compress or expand status for each group/subgroup
  saveWbCompressStatus(data, isCompress) {
    let ids = data.chldid.toString().split(".");
    let obj = {
      'loginId': this.userData.useracctid,
      'engagementId': this.engagementId,
      'acctYear': this.accYearEnd,
      'finGroupId': ids[0],
      'finSubGroupId': ids[1] ? ids[1] : 0,
      'isEnabled': !isCompress
    };

    this.apiService.saveWbCompressStatus(obj).subscribe(response => {
      if (response == "Success") {
        this.refreshIncomeStatement();
      }
    }, error => { });
  }

  getSubGroupSortingData(data, event, isRefresh: boolean, finsubgroupchildId?) {
    this.sortOrder = this.isASC;
    this.autoSortApplied = false;
    this.pageX = event.pageX;
    this.pageY = event.pageY;
    const span: HTMLElement = document.querySelector('.sort-position');
    span.style.left = (this.pageX - 120 - this.addPixel) + 'px';
    span.style.top = (this.pageY - 65) + 'px';
    this.subGroupSubModuleId = data.submoduleid;
    this.finSubGroupId = data.id;
    this.finsubgroupchildId = finsubgroupchildId;
    // this.applySort(isRefresh);
    this.sortData = [];
    if (data?.children && data.children.length) {
      data.children.forEach(subChild => {
        this.sortData.push({
          "finsubgroupchildId": subChild.id,
          "subgroupname": subChild.name,
          "value": (subChild.Currbal == '-') ? "0" : ((subChild.Currbal).includes('(') ? "-" + ((subChild.Currbal).replace(/[{(,)}]/g, '')) : ((subChild.Currbal).replace(/,/g, '')) + ""),
          "sortvalue": subChild.Currbal,
          "childid": subChild.chldid,
          "bsissortorderid": subChild.bsissortorderid,
          "bsissortorderitemid": subChild.bsissortorderitemid,
          "submoduleid": data.submoduleid,
          "checked": this.finsubgroupchildId == subChild.id ? true : false,
          "isuseradded": subChild?.isuseradded ? subChild.isuseradded : 0
        })
      });
      this.sortingMenu.openMenu();
      this.disableSort = true;
      this.sortGroup = 'AUTO';
      this.checkedManualData = [];
      this.sortCheckboxLength = 0;
    }
  }
  applySort(isRefresh: boolean) {
    const inputObj = {
      "engagementsid": this.engagementId,
      "acctyear": parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.datePipe.transform(this.engagementData.yearEnd, 'y')),
      "finsubgrpid": this.finSubGroupId,
      "submoduleid": this.submoduleId
    }
    this.updateSpinnerConfig(true);
    this.apiService.getSubgroupSort(this.userData.useracctid, inputObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
      if (response) {
        const res = JSON.parse(response);
        this.sortData = res;
        this.sortData.forEach(e => {
          if (e.finsubgroupchildId == this.finsubgroupchildId) {
            e.checked = true;
          }
        })
        if (isRefresh === false) {
          this.sortingMenu.openMenu();
          this.disableSort = true;
          this.sortGroup = 'AUTO';
          this.checkedManualData = [];
          this.sortCheckboxLength = 0;
        }
      }
    }, error => {
      this.toastr.error(error.error);
    });
  }
  onCLickSaveSorting() {
    let inputData = [];
    let sortType = this.sortGroup == "AUTO" ? true : false;
    this.sortData.map(e => {
      if (e.checked) {
        this.finsubgroupchildId = e.finsubgroupchildId;
      }
      let obj = {
        "engagementsId": this.engagementId,
        "submoduleId": this.subGroupSubModuleId,
        "acctYear": parseInt(this.selectedYearEnd),
        "isAutomatic": sortType,//auto : true; manual: false
        "sortOrder": "desc",
        "finSubgroupChildId": e.finsubgroupchildId,
        "bsIsSortOrderId": e.bsissortorderid,
        "bsIsSortOrderItemId": e.bsissortorderitemid,
        "childId": e.childid,
        'loginId': this.userData.useracctid,
        "isUserAdded": e?.isuseradded ? e.isuseradded : 0
      }
      inputData.push(obj);
    })
    const inputObj = {
      "sort": inputData
    }
    this.updateSpinnerConfig(true);
    this.apiService.saveSubgroupSort(inputObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
      //this.apiService.saveData(finalInputObj).subscribe(response => {
      if (response) {
        let obj = { "submoduleid": this.submoduleId, "id": this.finSubGroupId }
        let event = { "pageX": this.pageX, "pageY": this.pageY }
        this.getSubGroupSortingData(obj, event, true, this.finsubgroupchildId);
        this.refreshPreview();
        this.getIncomeStatementDetails(this.searchText);
        this.toastr.success("Records sorted successfully");
        this.sortingMenu.closeMenu();
      }
    }, error => {
      this.toastr.error(error.error);
    });
  }
  closeSort() {
    this.sortingMenu.closeMenu();
    this.finsubgroupchildId = 0;
    this.isASC = this.sortOrder;
  }
  toggleSort(para) {
    if (para == 'group') {
      this.groupisASC = !this.groupisASC;
      if (this.groupisASC) {
        this.sortData.sort((a, b) => 0 - (a.subgroupname.toLowerCase() > b.subgroupname.toLowerCase() ? -1 : 1));
      } else if (!this.groupisASC) {
        this.sortData.sort((a, b) => 0 - (a.subgroupname.toLowerCase() > b.subgroupname.toLowerCase() ? 1 : -1));
      }
    } else if (para == 'amount') {
      this.amountisASC = !this.amountisASC;
      if (this.amountisASC) {
        this.sortData.sort(function (a, b) { return a.value - b.value })
      } else if (!this.amountisASC) {
        this.sortData.sort(function (a, b) { return b.value - a.value })

      }
    }
    this.disableSort = false;
    this.autoSortApplied = true;
  }
  manualSorting(type?) {
    let totalCount = this.sortData.length;
    let checkedIndex = this.sortData.findIndex(e => e.checked);
    if (type === "UP") {
      if (checkedIndex != 0)
        this.move(this.sortData, checkedIndex, checkedIndex - 1);
    }
    else {
      if (checkedIndex != totalCount - 1)
        this.move(this.sortData, checkedIndex, checkedIndex + 1);
    }
    this.disableSort = false;
  }
  move(arr, old_index, new_index) {
    while (old_index < 0) {
      old_index += arr.length;
    }
    while (new_index < 0) {
      new_index += arr.length;
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length;
      while ((k--) + 1) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }
  onChangeAddManualData(obj) {
    this.sortCheckboxLength = this.sortData.filter(e => e.checked === true).length;
    if (obj.checked === true) {
      this.checkedManualData.push(obj);
    } else {
      this.checkedManualData.map((x, index) => {
        if (x.finsubgroupchildId == obj.finsubgroupchildId) {
          this.checkedManualData.splice(index, 1);
        }
      })
    }
    if (this.checkedManualData.length == 0 || this.checkedManualData.length == this.sortData.length) {
      this.isDisableDownArrow = true;
      this.isDisableUpArrow = true;
      this.disableSort = true;
    } else {
      this.isDisableDownArrow = false;
      this.isDisableUpArrow = false;
      this.disableSort = false;
    }
  }
  disableSortBtn(value) {
    //autoSortApplied
    if (value === 'MAN') {
      this.disableSort = this.checkedManualData.length <= 0;
    } else if (value === 'AUTO') {
      this.disableSort = this.autoSortApplied !== true;
    }
  }
  incomeStatement(index, item) {
    return index; // or item.id
  }
  incomeStatementChild(index, item) {
    return index; // or item.id
  }
  incomeStatementSubChild(index, item) {
    return index; // or item.id
  }
  incomeStatementTrialbal(index, item) {
    return index; // or item.id
  }

  onDragMoved(event) { }

  getFSNotes() {
    this.isSelectAll = false;
    let jsonFileName = this.engagementId + '_notes.json';
    const uploadObj = {
      "module": modules[16],
      'firmId': this.userData.firmUserAcctId,
      "clientId": this.selectedEngagementDetails.clientfirmid,
      "engagementId": this.selectedEngagementDetails.engagementsid,
      "status": 0,
      "folderName": jsonFileName,
      'appSyncId': this.userData.useracctid,
      "extension": 'comp',
    }
    this.updateSpinnerConfig(true);
    this.apiService.getJsonData(uploadObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe((response: any) => {
      if (response) {
        this.notes = !response ? [] : JSON.parse(response);
        this.isHideFooterNotesToFS = this.notes.length ? true : false;

        this.notes.forEach(ele => {
          ele['isExpand'] = false;
          ele['is_checked'] = false;
          ele['highlight'] = false;
          if (ele.notes) {
            ele.notes.forEach(element => {
              element['is_checked'] = false;
              element['highlight'] = false;
            });
          }
        })
      }
    }, () => {
      this.notes = [];
      this.isHideFooterNotesToFS = !!this.notes.length;
    });
  }

  getBalancesheet_Notes_Link_Obj() {
    for (let i = 0; i < this.incomeStatementdetails.length; i++) {
      if (this.incomeStatementdetails[i].children && this.incomeStatementdetails[i].children.length) {
        for (let j = 0; j < this.incomeStatementdetails[i].children.length; j++) {
          if (this.incomeStatementdetails[i].children[j].children && this.incomeStatementdetails[i].children[j].children.length) {
            for (let k = 0; k < this.incomeStatementdetails[i].children[j].children.length; k++) {
              var indx = this.incomeStatementdetails[i].children[j].children.findIndex(x => x.chldid == this.notesSRc.chldid)
              if (indx > -1) {
                this.incomeStatementdetails[i].children[j].children[indx].notes = this.incomeStatementdetails[i].children[j].children[indx].notes ? this.incomeStatementdetails[i].children[j].children[indx].notes : [];
                return this.incomeStatementdetails[i].children[j].children[indx];
              }
            }
          }
        }
      }
    }
  }
  get_NotesSrc_Obj(event) {
    for (let i = 0; i < this.incomeStatementdetails.length; i++) {
      if (this.incomeStatementdetails[i].children) {
        for (let j = 0; j < this.incomeStatementdetails[i].children.length; j++) {
          if (this.incomeStatementdetails[i].children[j].children.find(x => x.chldid == event.chldid)) {
            return this.incomeStatementdetails[i].children[j].children.find(x => x.chldid == event.chldid)
          }
        }
      }
    }
  }
  getCheckedNotes() {
    var selected_Records = [];
    this.notes.forEach(elem => {
      if (elem.is_checked) {
        if (elem.notes) {
          elem.notes.forEach(element => {
            selected_Records.push(element)
          });
        }
        else {
          selected_Records.push(elem)
        }
      }
      else if (elem.notes) {
        elem.notes.forEach(element => {
          if (element.is_checked) {
            selected_Records.push(element)
          }
        });
      }
    })
    return selected_Records
  }
  saveLinkNotes() {
    var selected_Records = [];
    selected_Records = this.getCheckedNotes();
    var previously_Selected = this.getBalancesheet_Notes_Link_Obj();
    var linksavearray = [];
    selected_Records.forEach(sobj => {
      var indx = -1;
      if (previously_Selected.notes) {
        indx = previously_Selected.notes.findIndex(x => x.engNoteId == sobj.engNoteId)
      }
      var obj = {
        "engagementsId": this.engagementId,
        "finSubgroupChildId": this.notesSRc.chldid ? this.notesSRc.chldid : '',
        "finSubgroupId": '',
        "submoduleId": this.submoduleId,
        "noteName": sobj.name,
        "noteId": sobj.id.toString(),
        "engNoteId": sobj.engNoteId.toString(),
        "isChanged": 0,
        "isDelete": 0,
        'loginId': this.userData.useracctid,
        "acctYear": this.accYearEnd,
        "workbookNotesId": indx > -1 ? previously_Selected.notes[indx].workbooknotesid : 0
      }
      linksavearray.push(obj)
    })
    var payload = {
      "save": linksavearray.length > 0 ? linksavearray : [{
        "engagementsId": this.engagementId,
        "finSubgroupChildId": this.notesSRc.chldid ? this.notesSRc.chldid : '',
        "finSubgroupId": '',
        "submoduleId": this.submoduleId,
        "noteName": '',
        "noteId": '',
        "engNoteId": '0',
        "isChanged": 0,
        "isDelete": 0,
        'loginId': this.userData.useracctid,
        "acctYear": this.accYearEnd,
        "workbookNotesId": 0
      }]
    }
    this.apiService.saveNotesBalanceSheet(payload).subscribe(resp => {
      if (resp && resp == 'Success') {
        this.toastr.success("Successfully Completed")
        this.refreshPreview();
        this.getIncomeStatementDetails("");
      }
    })
  }
  navigateToNotesToFs(id) {
    this.router.navigate(['/trial-balance-working-sheet/fs-notes'], { queryParams: { NoteId: id } });
  }
  searchNotes() {
    if (this.searchKeyword != "" || this.searchKeyword.trim() != "") {
      if (this.notes.length) {
        this.notes.forEach(ele => {
          if (ele.notes && ele.notes.filter(x => x.name.toLowerCase().includes(this.searchKeyword.toLowerCase()))) {
            var indx = ele.notes.findIndex(y => y.name.toLowerCase().includes(this.searchKeyword.toLowerCase()));
            ele.isExpand = indx > -1 ? true : false;
            ele.highlight = indx > -1 ? true : false;
          } else {
            ele.isExpand = ele.name.toLowerCase().includes(this.searchKeyword.toLowerCase()) ? true : false;
            ele.highlight = ele.name.toLowerCase().includes(this.searchKeyword.toLowerCase()) ? true : false;
          }
        })
      }
    } else {
      this.notes.forEach(exp => {
        exp.isExpand = false;
        exp.highlight = false;
      })
    }

  }
  resetNotesIs_Checked() {
    if (this.notes.length) {
      this.notes.forEach(ele => {
        ele.is_checked = false;
        if (ele.notes) {
          ele.notes.forEach(element => {
            element.is_checked = false;
          });
        }
      })
    }
  }
  selectAll(event) {
    for (let index = 0; index < this.notes.length; index++) {
      this.notes[index].is_checked = event.checked
      if (this.notes[index].notes) {
        this.notes[index].notes.forEach(element => {
          element.is_checked = event.checked
        });
      }
    }

  }
  is_recordChecked(i, checkedType, j?) {
    if (checkedType == "category") {
      this.notes[i].is_checked = !this.notes[i].is_checked;
      if (this.notes[i].notes) {
        this.notes[i].notes.forEach(element => {
          element.is_checked = this.notes[i].is_checked == true ? true : false
        });
      }
      this.isSelectAll = this.notes.findIndex(x => x.is_checked == false) < 0 ? true : false
    } else if (checkedType == "subcategory") {
      this.notes[i].notes[j].is_checked = !this.notes[i].notes[j].is_checked;
      this.notes[i].is_checked = this.notes[i].notes.findIndex(x => x.is_checked == false) < 0 ? true : false
      this.isSelectAll = this.notes.findIndex(x => x.is_checked == false) < 0 ? true : false
    }
  }

  changednotesLinks(event?) {
    this.resetNotesIs_Checked()
    this.notesSRc = event ? this.get_NotesSrc_Obj(event) : this.notesSRc
    var balance_obj = event ? event : this.getBalancesheet_Notes_Link_Obj();
    this.disablegreenbutton = (balance_obj.notes && balance_obj.notes.length > 0) ? true : false
    if (balance_obj.notes) {
      for (let k = 0; k < this.notes.length; k++) {
        for (let i = 0; i < balance_obj.notes.length; i++) {
          if (this.notes[k].engNoteId == balance_obj.notes[i].engNoteId) {
            this.is_recordChecked(k, 'category');
          } else if (this.notes[k].notes) {
            for (let j = 0; j < this.notes[k].notes.length; j++) {
              if (this.notes[k].notes[j].engNoteId == balance_obj.notes[i].engNoteId) {
                this.is_recordChecked(k, 'subcategory', j);
              }
            }
          }
        }
      }
    }
  }
  notesFSLinkingSelectionDialogFunc(child2?) {
    // this.resetNotesIs_Checked();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '100%';
    dialogConfig.position = { 'top': '53px', right: '0' };
    this.changednotesLinks(child2);
    const dialogRef = this.dialog.open(this.notesFSLinkingDialog, dialogConfig);
    dialogRef.afterClosed().subscribe();
  }

  ngOnDestroy() {
    clearTimeout(this.userActivity);
  }

  showFormattedNumber(data: number) {
    if (data > 0) {
      return data.toLocaleString('en-us');
    } else if (data < 0) {
      const absoluteNumber = data * -1;
      const formatted = absoluteNumber.toLocaleString('en-US');
      return '(' + formatted + ')';
    } else {
      return '-';
    }
  }

  // get FS settings data to know which year data to be shown
  getFsSettings() {
    this.isViewSeparated = false;
    let typeOfEntityId = this.engagementData.typeofentityid ? this.engagementData.typeofentityid : this.engagementData.typeOfEntityId;
    const isTaxEngagement = this.engservice.isTaxTemplate(this.engagementData);
    if (isTaxEngagement) {
      this.getIncomeStatementDetails(this.searchText);
      return;
    } else {
      this.apiService.getFsSettings(this.engagementData.engagementsid, typeOfEntityId).subscribe(response => {
        if (response) {
          const fsSettingsData = JSON.parse(response);
          fsSettingsData.forEach(e => {
            if (e.settings != null) {
              e.settings.forEach(setting => {
                if (setting.engFinSettingId === 3) {
                  if ((setting.selectedOption == 'Yes')) {
                    localStorage.setItem('workBookSubmoduleId', '436');
                    this.submoduleId = JSON.parse(localStorage.getItem('workBookSubmoduleId'));
                    this.isViewSeparated = true;
                  } else {
                    localStorage.setItem('workBookSubmoduleId', '437');
                    this.submoduleId = JSON.parse(localStorage.getItem('workBookSubmoduleId'));
                  }
                }

              })
            }
          });
          this.getIncomeStatementDetails(this.searchText);
        }
      }, error => {
        this.toastr.warning(error.error)
      })
    }
  }

  filterIncomeStatementDetails(searchTerm) {
    if (!searchTerm) {
      this.incomeStatementdetails = JSON.parse(JSON.stringify(this.originalIncomeStatementdetails));
      this.isSearchExist = false;
    } else {
      this.isSearchExist = false;

      const traverseAndUpdate = (node) => {
        let isAnyMatchFound = false;
        if (node.children) {
          node.children.forEach(child => {
            const childMatchFound = traverseAndUpdate(child);
            if (childMatchFound) {
              isAnyMatchFound = true;
            }
          });
        } else if (node.trialbal) {
          node.isexpand = "true";
          node.trialbal.forEach(item => {
            if (item.accountname.toLowerCase().includes(searchTerm.toLowerCase())) {
              item.isexpand = "true";
              item.ishighlight = 1;
              this.isSearchExist = true;
              isAnyMatchFound = true;
            } else {
              item.isexpand = "false";
              item.ishighlight = 0;
            }
          });
          if (!isAnyMatchFound) {
            node.isexpand = "false";
          }
          return isAnyMatchFound;
        }
      };
      this.incomeStatementdetails = JSON.parse(JSON.stringify(this.originalIncomeStatementdetails));
      this.incomeStatementdetails.forEach(group => {
        traverseAndUpdate(group);
      });
    }
  }


  // current and Previous
  getPreviousAndCurrentDate() {
    const data = this.engservice.getPreviousAndCurrentDate(this.yearEndDetails, this.selectedYearEnd);
    this.currentYearIS = data.currentYear;
    this.selectedYearTitle = data.selectedYearTitle;
    this.previousYearIS = data.previousYear;
  }

  private updateSpinnerConfig(value: boolean) {
    value ? this.spinCount++ : (this.spinCount = Math.max(0, this.spinCount - 1));
    this.spinnerConfig.update((config) => ({ ...config, isSpinShown: this.spinCount > 0 }));
  }


}




